<template>
  <div>
    <bv-top></bv-top>
    <van-swipe :width="width" :loop="false" @change="houseSwipeChange">
      <van-swipe-item :key="'house_' + house.houseId" v-for="house in houseList">
        <card-detail>
          <template #title>
            <van-cell class="addressCell" :title="house.detailAddress"></van-cell>
          </template>
          <template slot="content">
            <van-row type="flex" justify="space-between" class="content">
              <van-col span="24" class="content-left">
                {{house.constructArea}}m²/{{house.houseUse}}
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
              <van-col span="24" class="content-left" v-if="house.contractType === '1'">
                预售合同/{{house.contractState}}
              </van-col>
              <van-col span="24" class="content-left" v-else>
                存量房合同/{{house.contractState}}
              </van-col>
            </van-row>
          </template>
          <template slot="footer">
            <div class="footer">
              <van-tag type="primary" plain round size="large">{{house.presellState}}</van-tag>
<!--              <van-tag type="primary" plain round size="large" v-if="house.mortgageFlag === '是'">抵押</van-tag>-->
<!--              <van-tag type="primary" plain round size="large" v-if="house.closeFlag === '是'">查封</van-tag>-->
              <van-tag type="primary" plain round size="large"
                       v-if="house.frozenFlag === '是' || house.presellState === '关闭'">关闭
              </van-tag>
              <van-tag type="primary" plain round size="large" v-if="house.pledgeFlag === '是'">在建抵押</van-tag>

            </div>
          </template>
        </card-detail>
      </van-swipe-item>
    </van-swipe>
    <van-tabs active="true" color="#08e8de" animated v-if="initHouse">
      <van-tab title="基本信息">
        <van-cell-group v-if="house.basic != null">
          <van-cell :title="house.basic.detailAddress" :value="house.basic.houseType"/>
          <van-cell title="房屋用途" :value="house.basic.houseUse"/>
          <van-cell title="房屋户型" :value="house.basic.houseHold"/>
          <van-cell title="房屋朝向" :value="house.basic.roomDirection"/>
          <van-cell title="单元总层数" :value="house.basic.overFloor" v-if="house.contractType === '1'"/>
          <van-cell title="建筑面积(㎡)" :value="house.basic.constructArea"/>
          <van-cell title="套内面积(㎡)" :value="house.basic.ownArea"/>
          <van-cell title="公摊面积(㎡)" :value="house.basic.shareArea"/>
          <!--                    <van-cell title="阳台面积(㎡)" :value="house.basic.balconyArea" />
                              <van-cell title="阳台个数" :value="house.basic.balconyNum" />-->
        </van-cell-group>
        <van-empty v-if="house.basic == null" description="没有更多内容"/>
      </van-tab>
      <van-tab title="预售合同" v-if="house.contract != null&& house.contract.contractType === '1'">
        <van-cell-group>
          <van-cell title="合同状态" :value="house.contract.contractState"/>
          <van-cell title="合同编号" :value="house.contract.contractNo"/>
          <van-cell title="合同金额" :value="'¥'+house.contract.contractAmount"/>
          <van-cell title="房屋地址" :value="house.contract.detailAddress"/>
          <van-cell title="建筑面积(㎡)" :value="house.contract.constructArea"/>
          <van-cell title="售价(元/㎡)" :value="house.contract.realPrice"/>
          <van-cell title="买受人" :value="house.contract.buyerNames"/>
          <van-cell title="签订日期" :value="house.contract.signDate"/>
          <van-row type="flex" justify="center" v-if="house.contract.signDate.substring(0,10)>='2022-04-01'">
            <van-col span="22" style="text-align: center">
              <van-button type="primary" size="small" class="btn" @click="downloadXjFile(house.contract.contractDownloadId)">合同下载</van-button>
            </van-col>
          </van-row>
          <!--                    <van-cell title="备案日期" :value="house.contract.recordDate" />
                              <van-cell title="付款方式" :value="house.contract.payType" />-->
        </van-cell-group>
        <van-empty v-if="house.contract == null" description="没有更多内容"/>
      </van-tab>
      <van-tab title="存量房合同" v-if="house.contract != null&& house.contract.contractType === '2'">
        <van-cell-group>
          <van-cell title="合同状态" :value="house.contract.contractState"/>
          <van-cell title="合同编号" :value="house.contract.contractNo"/>
          <van-cell title="合同金额" :value="'¥'+house.contract.contractAmount"/>
          <van-cell title="房屋地址" :value="house.contract.detailAddress"/>
          <van-cell title="建筑面积(㎡)" :value="house.contract.constructArea"/>
          <van-cell title="售价(元/套)" :value="house.contract.realPrice"/>
          <van-col span="24" class="content-left" v-if="house.contract.dsrlb === '4'">
            <van-cell title="买受人" :value="house.contract.buyerNames"/>
          </van-col>
          <van-col span="24" class="content-left" v-else>
            <van-cell title="出卖人" :value="house.contract.buyerNames"/>
          </van-col>
          <van-cell title="签订日期" :value="house.contract.signDate"/>
          <van-row type="flex" justify="center" v-if="house.contract.signDate.substring(0,10)>='2022-04-01'">
            <van-col span="22" style="text-align: center">
              <van-button type="primary" size="small" class="btn" @click="downloadClfFile(house.contract.contractDownloadId)">合同下载</van-button>
            </van-col>
          </van-row>

          <!--                    <van-cell title="备案日期" :value="house.contract.recordDate" />
                              <van-cell title="付款方式" :value="house.contract.payType" />-->
        </van-cell-group>
        <van-empty v-if="house.contract == null" description="没有更多内容"/>
      </van-tab>
<!--      <van-tab title="抵押信息">-->
<!--        <template v-if="house.mortgage!=null && house.mortgage.length>0">-->
<!--          <van-cell-group class="my-card-cell-group" v-for="item in house.mortgage" :key="'mortgage_'+item.bh" inset>-->
<!--            <van-cell :title="item.ywh" :value="item.jy==='Y'?'解押':''" style="color:red"/>-->
<!--            <van-cell title="抵押权人" :value="item.dyqr"/>-->
<!--            <van-cell title="抵押人" :value="item.dyr"/>-->
<!--            <van-cell title="贷款金额" :value="'¥'+item.zqse"/>-->
<!--            <van-cell title="债务履行期限始" :value="item.zwqxq"/>-->
<!--            <van-cell title="债务履行期限止" :value="item.zwqxz"/>-->
<!--          </van-cell-group>-->
<!--        </template>-->
<!--        -->
<!--        <van-empty v-if="house.mortgage == null || house.mortgage.length===0" description="没有更多内容"/>-->
<!--      </van-tab>-->
<!--      <van-tab title="查封信息">-->
<!--        <template v-if="house.close!=null && house.close.length>0">-->
<!--          <van-cell-group class="my-card-cell-group" v-for="item in house.close" :key="'close_'+item.bh" inset>-->
<!--            <van-cell :title="item.ywh" :value="item.jf==='Y'?'解除查封':''" style="color:red"/>-->
<!--            <van-cell title="查封机关" :value="item.cfjg"/>-->
<!--            <van-cell title="被查封人" :value="item.bcfr"/>-->
<!--            <van-cell title="查封日期始" :value="item.cfqssj"/>-->
<!--            <van-cell title="查封日期止" :value="item.cfjssj"/>-->
<!--          </van-cell-group>-->
<!--        </template>-->
<!--        <van-empty v-if="house.close == null || house.close.length===0" description="没有更多内容"/>-->
<!--      </van-tab>-->
    </van-tabs>
    <van-notice-bar left-icon="volume-o"
                    text="尊敬的用户，没有查询到您名下商品房网签备案合同信息。"
                    v-show="noResultShow"
    />
    <van-empty v-show="noResultShow" description="没有更多内容"/>
  </div>
</template>

<script>

  import {Swipe, SwipeItem, NoticeBar, Tag} from 'vant';
  import Top from '@/views/components/Top'
  import CardDetail from '@/components/card-detail.vue'
  // import ContentItem from '@/components/content-item.vue'
  import {fetchMyHouses, fetchHouseInfo} from "@/api/houseResource/house"

  export default {
    name: "MyHouse",
    components: {
      BvTop: Top,
      VanSwipe: Swipe,
      VanSwipeItem: SwipeItem,
      VanNoticeBar: NoticeBar,
      VanTag: Tag,
      CardDetail
      // ,ContentItem
    },
    data() {
      return {
        message: '',
        houseList: [],
        noResultShow: false,
        houseId: '',
        initHouse: false,
        house: {},
        storeHouses: {},
        width: 300,
        contractDownloadId:''
      }
    },
    watch: {
      houseId() {
        this.initHouse = false;
        // 将回调延迟到下次 DOM 更新循环之后执行。在修改数据之后立即使用它，然后等待 DOM 更新。
        this.$nextTick(() => {
          this.initHouse = true;
        });
      }
    },
    mounted() {
      this.width = screen.width * 0.9;
      this.fetchMyHouses();
    },
    methods: {
      fetchMyHouses() {
        fetchMyHouses().then(res => {
          this.houseList = res.data;
          if (this.houseList.length === 0) {
            this.noResultShow = true;
          } else {
            this.houseId = this.houseList[0].houseId;
            this.getHouse(this.houseId);
          }
        });
      },
      houseSwipeChange(index) {
        this.houseId = this.houseList[index].houseId;
        this.getHouse(this.houseId);
      },
      getHouse(houseId) {
        if (this.storeHouses[houseId]) {
          this.house = this.storeHouses[houseId]
        } else {
          fetchHouseInfo(houseId).then(res => {
            this.house = res.data;
            this.storeHouses[houseId] = res.data;
          });
        }
      },
      downloadXjFile(contractDownloadId) {
        console.log("contractDownloadId="+contractDownloadId)
        const link = document.createElement('a')
        link.href = this.$APP_ROOT + '/api/maintenance-fund/weixin/contractXjPdf/'+contractDownloadId
        link.download = this.fileName
        link.style.display = 'none'
        link.click()
        this.showPopup = false
      },
      downloadClfFile(contractDownloadId) {
        console.log("contractDownloadId="+contractDownloadId)
        const link = document.createElement('a')
        link.href = this.$APP_ROOT + '/api/maintenance-fund/weixin/contractClfPdf/'+contractDownloadId
        link.download = this.fileName
        link.style.display = 'none'
        link.click()
        this.showPopup = false
      },
    }
  }
</script>

<style lang='scss' scoped>
  .my-card-cell-group {
    border: 1px solid #ccc;
    border-radius: 8px;
    margin-top: 10px;
  }

  .content {
    padding: 10px 0;
  }

  .addressCell {
    background-color: #eacd76;
    background-image: linear-gradient(90deg, #bbf0f9 20%, #fbfbfb 99%);
  }

  .content-left {
    color: #999;
  }
</style>
